var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader-wrapper',[_c('el-badge',[_c('div',{class:[
        'check-list-flags__flag is-act',
        { active: true },
        _vm.response['act-status'] ]},[_vm._v("\n      АКТ\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }